import React from "react";
import { Table, Popconfirm, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export const TablaProduct = ({ dataSource, setDataSource }) => {
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const columns = [
    {
      title: "Categoria de producto",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: "Marca",
      dataIndex: "brand",
      key: "brand",
    },
    {
      title: "Talla",
      dataIndex: "size",
      key: "size",
    },
    {
      title: "Modelo",
      dataIndex: "model",
      key: "model",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
    },
    {
      title: "Accion",
      dataIndex: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
         <Popconfirm
title="¿Desea eliminar este producto?"
onConfirm={() => handleDelete(record.key)}
okText="Si"
cancelText="No"
placement="topRight"
>
<Typography.Link style={{ marginLeft: "10px" }} className="text-link">
  <DeleteOutlined />
</Typography.Link>
</Popconfirm>


        ) : null,
    },
  ];

  return (
    <div>
      <Table dataSource={dataSource} columns={columns}  scroll={{x: 510}}/>
    </div>
  );
};
